import { useAppSelector } from "../../../app/hook";
import { selectClient } from "../../../features/dashboard.slice";
import AffiliationShareBlock from "./sections/AffiliationShareBlock";
import GraphUserCounter from "./sections/GraphUserCounter";
import GraphContributionCounter from "./sections/GraphContributionCounter";
import CommissionSimulatorBlock from "./sections/CommissionSimulatorBlock";
import ContributionSimulatorBlock from "./sections/ContributionSimulatorBlock";
import PartnerAffiliateLevel from "./partnerAffiliateLevel";
import PartnerContributorLevel from "./partnerContributorLevel";
import { PARTNER_LEVEL, PARTNER_TYPE } from "../../../utils/partnerObject";

const LEVEL_TARGETS_CONTRIBUTOR = {
  STANDARD: 100,
  BRONZE: 1000,
  SILVER: 10000,
  GOLD: 1000000
};

const LEVEL_TARGETS_AFFILIATE = {
  STANDARD: 10,
  BRONZE: 100,
  SILVER: 1000,
  GOLD: 10000
};

function PartnerUserStats({
  type,
  level,
  monthlySales
}: {
  type: PARTNER_TYPE.AFFILIATE | PARTNER_TYPE.CONTRIBUTOR;
  level:
    | PARTNER_LEVEL.STANDARD
    | PARTNER_LEVEL.BRONZE
    | PARTNER_LEVEL.SILVER
    | PARTNER_LEVEL.GOLD;
  monthlySales: number;
}) {
  let nextLevel:
    | PARTNER_LEVEL.STANDARD
    | PARTNER_LEVEL.BRONZE
    | PARTNER_LEVEL.SILVER
    | PARTNER_LEVEL.GOLD;
  let currentTarget = 10;
  if (type === PARTNER_TYPE.CONTRIBUTOR) {
    nextLevel = Object.keys(LEVEL_TARGETS_CONTRIBUTOR)[
      Object.keys(LEVEL_TARGETS_CONTRIBUTOR).indexOf(level) + 1
    ] as keyof typeof LEVEL_TARGETS_CONTRIBUTOR;
    currentTarget = LEVEL_TARGETS_CONTRIBUTOR[level];
  } else if (type === PARTNER_TYPE.AFFILIATE) {
    nextLevel = Object.keys(LEVEL_TARGETS_AFFILIATE)[
      Object.keys(LEVEL_TARGETS_AFFILIATE).indexOf(level) + 1
    ] as keyof typeof LEVEL_TARGETS_AFFILIATE;
    currentTarget = LEVEL_TARGETS_AFFILIATE[level];
  }

  const client = useAppSelector(selectClient);

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <div>
        {type === PARTNER_TYPE.AFFILIATE ? (
          <PartnerAffiliateLevel
            sales={monthlySales ?? 0}
            level={level}
            nextLevel={nextLevel}
            currentTarget={currentTarget}
          />
        ) : type === PARTNER_TYPE.CONTRIBUTOR ? (
          <PartnerContributorLevel
            usage={monthlySales ?? 0}
            level={level}
            nextLevel={nextLevel}
            currentTarget={currentTarget}
          />
        ) : (
          <></>
        )}
      </div>
      {type === PARTNER_TYPE.AFFILIATE && (
        <div className="tw-w-full tw-bg-gray-100 tw-rounded-lg">
          <AffiliationShareBlock sumId={client?.sum_identification as string} />
        </div>
      )}

      <div className="tw-grid tw-grid-cols-2 tw-gap-4">
        <div className="md:tw-col-span-1 tw-col-span-2">
          <div className="tw-w-full tw-bg-gray-100 tw-rounded-lg">
            {type === PARTNER_TYPE.AFFILIATE ? (
              <GraphUserCounter />
            ) : type === PARTNER_TYPE.CONTRIBUTOR ? (
              <GraphContributionCounter />
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="md:tw-col-span-1 tw-col-span-2">
          <div className="tw-w-full tw-bg-gray-100 tw-rounded-lg">
            {type === PARTNER_TYPE.AFFILIATE ? (
              <CommissionSimulatorBlock
                simulationSales={LEVEL_TARGETS_AFFILIATE[nextLevel] - 5}
                level={!level ? PARTNER_LEVEL.STANDARD : level}
                nextLevel={
                  level === PARTNER_LEVEL.STANDARD
                    ? PARTNER_LEVEL.BRONZE
                    : nextLevel
                }
              />
            ) : type === PARTNER_TYPE.CONTRIBUTOR ? (
              <ContributionSimulatorBlock
                usage={LEVEL_TARGETS_CONTRIBUTOR[nextLevel] - 5}
                level={!level ? PARTNER_LEVEL.STANDARD : level}
                nextLevel={
                  level === PARTNER_LEVEL.STANDARD
                    ? PARTNER_LEVEL.BRONZE
                    : nextLevel
                }
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartnerUserStats;
